import { QuestionFormat } from '../enum/question-format';
import { CKTextView } from './ck-text.view';
import { RichView } from './editor/rich.view';
import { MarkdownTextView } from './markdown-text.view';

export interface CustomTextViewProps {
  format: QuestionFormat;
  initData?: string;
  showMore?: boolean;
  className?: string;
}

export const CustomTextView = (props: CustomTextViewProps) => {
  const { format, initData = '', showMore = false, className } = props;

  return (
    <div
      className={`mx-2 my-3 font-sans w-full ${className ? className : ''}`}
      style={{
        fontSize: '1.1em',
        lineHeight: '1.4',
      }}
    >
      {format === QuestionFormat.RICH_HTML ? (
        // <CKTextView initData={initData} showMore={showMore} />
        <RichView html={initData} showMore={showMore} />
      ) : (
        <MarkdownTextView initData={initData} />
      )}
    </div>
  );
};
